<template>
  <div class="lv-info-box pa-3" :class="{disable}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    disable: {
      type: Boolean,
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/lv-info-box.scss";
</style>